import script from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MainFooter.vue?vue&type=style&index=0&id=7feafdce&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7feafdce"]])

export default __exports__